import React from 'react';
import styled from 'styled-components';

export type StatusMapItem = {
    status: string;
    label: React.ReactNode;
    color: string;
    backgroundColor: string;
    borderColor: string;
};

export type StatusViewProps = {
    status: string;
    statusMap: StatusMapItem[];
    className?: string;
};

export const StatusView: React.FC<StatusViewProps> = ({
    status,
    statusMap,
    className,
}) => {
    const config = statusMap.find((item) => item.status === status);

    if (!config) {
        return (
            <StyledStatusView className={className}>{status}</StyledStatusView>
        );
    }

    return (
        <StyledStatusView
            className={className}
            $color={config.color}
            $backgroundColor={config.backgroundColor}
            $borderColor={config.borderColor}
        >
            {config.label}
        </StyledStatusView>
    );
};

const StyledStatusView = styled.span<{
    $color?: string;
    $backgroundColor?: string;
    $borderColor?: string;
}>`
    display: inline-block;
    padding: 2px 12px;
    border-radius: 12px;
    border: 1px solid transparent;
    font-size: 0.875rem;
    line-height: 1.5;
    white-space: nowrap;
    background-color: var(--status-default-bg-color);
    color: var(--status-default-color);

    ${({ $color }) => $color && `color: ${$color};`}
    ${({ $backgroundColor }) =>
        $backgroundColor && `background-color: ${$backgroundColor};`}
    ${({ $borderColor }) => $borderColor && `border-color: ${$borderColor};`}
`;
